<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box p-0">
        <a routerLink="/dashboard" class="logo logo-dark">
          <span class="logo-sm">
            <img [src]="wl.logoSmallUrl" [alt]="wl.appName" height="20" />
          </span>
          <span class="logo-lg">
            <img [src]="wl.logoUrl" [alt]="wl.appName" height="50" />
          </span>
        </a>
        <a routerLink="/dashboard" class="logo logo-light">
          <span class="logo-sm">
            <img [src]="wl.logoSmallUrl" [alt]="wl.appName" height="20" />
          </span>
          <span class="logo-lg">
            <img [src]="wl.logoUrl" [alt]="wl.appName" height="50" />
          </span>
        </a>
      </div>

      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- Back button + Page title -->
      <div class="d-flex align-items-center ms-1">
        <is-button
          *ngIf="canGoBack"
          variant="ghost"
          size="sm"
          shape="circle"
          icon="bx-arrow-back"
          [tooltip]="'COMMON.BACK' | translate"
          (clicked)="goBack()"
        ></is-button>
        <h6 *ngIf="pageTitle" class="mb-0 fw-semibold text-dark ms-2" style="font-size: 0.9rem;">{{ pageTitle }}</h6>
      </div>
    </div>

    <div class="d-flex align-items-center gap-2">
      <!-- Busca global -->
      <div class="d-none d-lg-block topbar-search-wrapper">
        <is-autocomplete-field
          #searchField
          [options]="searchPages"
          [placeholder]="'COMMON.SEARCH' | translate"
          prefixIcon="bx-search"
          [minChars]="1"
          [maxResults]="6"
          (optionSelected)="onPageSelected($event)"
        ></is-autocomplete-field>
        <span class="topbar-search-shortcut">Ctrl+Shift+A</span>
      </div>

      <!-- Seletor de Contratante -->
      <div class="d-inline-block topbar-contractor-wrapper" *ngIf="showContractorSelector">
        <ng-select
          [items]="contractors"
          bindLabel="name"
          [(ngModel)]="selectedContractor"
          [searchable]="true"
          [clearable]="false"
          (change)="onContractorChange($event)"
          [placeholder]="'CONTRACTOR.SELECT.PLACEHOLDER' | translate"
          class="header-contractor-select"
        ></ng-select>
      </div>

      <!-- Tela cheia -->
      <is-button
        variant="ghost"
        size="sm"
        shape="circle"
        icon="bx-fullscreen"
        tooltip="Fullscreen"
        (clicked)="fullscreen()"
      ></is-button>

      <!-- Notificações (desabilitado — funcionalidade futura)
      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="topbar-btn position-relative"
          id="page-header-notifications-dropdown"
          ngbDropdownToggle
        >
          <i class="bx bx-bell"></i>
          <span *ngIf="unreadNotifications > 0" class="topbar-badge">{{ unreadNotifications }}</span>
        </button>
        <div class="dropdown-menu dropdown-menu-end topbar-notif-dropdown p-0" ngbDropdownMenu>
          <div class="topbar-notif-dropdown__header">
            <span class="fw-semibold">{{ 'HEADER.NOTIFICATIONS' | translate }}</span>
            <span class="badge bg-danger rounded-pill">{{ unreadNotifications }}</span>
          </div>
          <div class="topbar-notif-dropdown__list">
            <a *ngFor="let notif of notifications" href="javascript:void(0);" class="topbar-notif-dropdown__item">
              <div class="topbar-notif-dropdown__icon" [class]="'bg-' + notif.color + '-subtle text-' + notif.color">
                <i [class]="'bx ' + notif.icon"></i>
              </div>
              <div class="topbar-notif-dropdown__content">
                <p class="topbar-notif-dropdown__title">{{ notif.title }}</p>
                <p class="topbar-notif-dropdown__msg">{{ notif.message }}</p>
              </div>
              <span class="topbar-notif-dropdown__time">{{ notif.time }}</span>
            </a>
          </div>
          <div class="topbar-notif-dropdown__footer">
            <a href="javascript:void(0);">{{ 'HEADER.VIEW_ALL' | translate }}</a>
          </div>
        </div>
      </div>
      -->

      <!-- Dropdown Usuário -->
      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="topbar-btn"
          ngbDropdownToggle
          id="page-header-user-dropdown"
        >
          <img
            class="rounded-circle"
            src="../../../assets/images/users/avatar-wkf.svg"
            alt="Avatar"
            width="28"
            height="28"
          />
        </button>

        <div class="dropdown-menu dropdown-menu-end topbar-user-dropdown p-0" ngbDropdownMenu>
          <!-- User header -->
          <div class="topbar-user-dropdown__header">
            <img
              class="rounded-circle"
              src="../../../assets/images/users/avatar-wkf.svg"
              alt="Avatar"
              width="40"
              height="40"
            />
            <div>
              <p class="topbar-user-dropdown__name">{{ username }}</p>
              <p class="topbar-user-dropdown__role">Administrador</p>
            </div>
          </div>

          <!-- Tema -->
          <div class="topbar-user-dropdown__section">
            <a class="topbar-user-dropdown__item" href="javascript:void(0);" (click)="toggleTheme()">
              <i [class]="'bx ' + themeIcon"></i>{{ themeLabel }}
            </a>
          </div>

          <!-- Idioma -->
          <div class="topbar-user-dropdown__section">
            <a
              class="topbar-user-dropdown__item"
              href="javascript:void(0);"
              (click)="langExpanded = !langExpanded"
            >
              <img [src]="flagvalue" [alt]="countryName" height="14" width="20" style="border-radius:2px;" />
              {{ countryName }}
              <i class="bx ms-auto" [class.bx-chevron-down]="!langExpanded" [class.bx-chevron-up]="langExpanded" style="font-size:0.85rem;"></i>
            </a>
            <div *ngIf="langExpanded" class="topbar-user-dropdown__lang-list">
              <a
                *ngFor="let item of listLang"
                href="javascript:void(0);"
                class="topbar-user-dropdown__item topbar-user-dropdown__item--sub"
                (click)="setLanguage(item.text, item.lang, item.flag, item.value); langExpanded = false"
                [class.topbar-user-dropdown__item--active]="cookieValue === item.lang"
              >
                <img [src]="item.flag" [alt]="item.text" height="14" width="20" style="border-radius:2px;" />
                {{ item.text }}
                <i *ngIf="cookieValue === item.lang" class="bx bx-check ms-auto text-success"></i>
              </a>
            </div>
          </div>

          <!-- Sair -->
          <div class="topbar-user-dropdown__section topbar-user-dropdown__section--danger">
            <a class="topbar-user-dropdown__item" href="javascript:void(0);" (click)="logout()">
              <i class="bx bx-power-off"></i>{{ "MENU.LOGOUT" | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
